var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4933 3.75C16.4933 2.925 15.8258 2.25 15.0008 2.25H3.00076C2.17576 2.25 1.50076 2.925 1.50076 3.75V12.75C1.50076 13.575 2.17576 14.25 3.00076 14.25H13.5008L15.5925 16.3417C15.9278 16.677 16.5 16.4393 16.5 15.9653L16.4933 3.75ZM9.75001 12H6.00001C5.58601 12 5.25001 11.664 5.25001 11.25C5.25001 10.836 5.58601 10.5 6.00001 10.5H9.75001C10.164 10.5 10.5 10.836 10.5 11.25C10.5 11.664 10.164 12 9.75001 12ZM12 9H6.00001C5.58601 9 5.25001 8.664 5.25001 8.25C5.25001 7.836 5.58601 7.5 6.00001 7.5H12C12.414 7.5 12.75 7.836 12.75 8.25C12.75 8.664 12.414 9 12 9ZM12 6H6.00001C5.58601 6 5.25001 5.664 5.25001 5.25C5.25001 4.836 5.58601 4.5 6.00001 4.5H12C12.414 4.5 12.75 4.836 12.75 5.25C12.75 5.664 12.414 6 12 6Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxTemplates);
export default __webpack_public_path__ + "static/media/inbox-templates.109dc36cf718628e299404d1d770eea9.svg";
export { ForwardRef as ReactComponent };